import React, { useEffect, useState } from 'react';
import LoginView from './components/LoginView';
import NameView from './components/NameView';
import QuestionView from './components/QuestionView';
import AnswerFeedbackView from './components/AnswerFeedbackView';
import ResultView from './components/ResultView';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [step, setStep] = useState("login");
  const [clubInfo, setClubInfo] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showFeedback, setShowFeedback] = useState(null);
  const [nameHint, setNameHint] = useState("");

  // Admin-Token bei Quizende löschen
  useEffect(() => {
    if (step === 'result') {
      localStorage.removeItem('adminToken');
    }
  }, [step]);

  // Dynamische iframe-Höhe an WordPress-Parent
  useEffect(() => {
    const updateHeight = () => {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'resize-quiz', height }, '*');
    };

    updateHeight();
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(document.body);

    return () => resizeObserver.disconnect();
  }, []);

  // Hinttext für Namenseingabe laden
  useEffect(() => {
    fetch('https://quizapi.steilpass-fussballjobs.de/api/hints/name')
      .then(res => res.json())
      .then(data => setNameHint(data.content));
    }, []);

  const fetchQuestions = async () => {
    const res = await fetch('https://quizapi.steilpass-fussballjobs.de/api/admin/questions');
    const data = await res.json();
    setQuestions(data);
  };

  const handleLogin = async (code) => {
    const res = await fetch('https://quizapi.steilpass-fussballjobs.de/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code })
    });
    const data = await res.json();
    if (data.success) {
      setClubInfo({ clubId: data.clubId, clubName: data.clubName, code });
      setStep("name");
    } else {
      alert("Ungültiger Code");
    }
  };

  const handleStart = async (firstName, lastName) => {
    setUserInfo({ firstName, lastName });
    await fetch('https://quizapi.steilpass-fussballjobs.de/api/start', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName, lastName, code: clubInfo.code
      })
    });
    await fetchQuestions();
    setStep("quiz");
  };

  const handleAnswer = async (isCorrect, question) => {
    if (isCorrect) setScore(prev => prev + 1);

    setShowFeedback({
      isCorrect,
      explanation: question.explanation,
      source: question.source
    });

    await fetch('https://quizapi.steilpass-fussballjobs.de/api/answer-log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        code: clubInfo.code,
        questionId: question._id,
        answerText: question.answers.find(a => a.isCorrect === isCorrect)?.text || 'Unbekannt',
        isCorrect
      })
    });
  };

  const handleNext = () => {
    setShowFeedback(null);
    const next = currentQuestion + 1;
    if (next < questions.length) {
      setCurrentQuestion(next);
    } else {
      setStep("result");

      fetch('https://quizapi.steilpass-fussballjobs.de/api/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          firstName: userInfo.firstName,
          lastName: userInfo.lastName,
          score
        })
      });
    }
  };

  return (
    <>
      {/* Logoleiste oben */}
      <div className="partner-logos d-flex justify-content-center align-items-center mb-4 flex-wrap" style={{ marginTop: '20px' }}>
        <img
          src={`${process.env.PUBLIC_URL}/logos/kickin.png`}
          alt="KickIn!"
          className="partner-logo"
        />
      </div>

      {step === "login" && <LoginView onSuccess={handleLogin} />}
      {step === "name" && <NameView onStart={handleStart} hintText={nameHint} />}
      {step === "quiz" && questions.length > 0 && !showFeedback && (
        <QuestionView
          question={questions[currentQuestion]}
          onAnswer={(isCorrect) => handleAnswer(isCorrect, questions[currentQuestion])}
        />
      )}
      {step === "quiz" && showFeedback && (
        <AnswerFeedbackView
          correct={showFeedback.isCorrect}
          explanation={showFeedback.explanation}
          source={showFeedback.source}
          onNext={handleNext}
        />
      )}
      {step === "result" && <ResultView score={score} />}
    </>
  );
}

export default App;
